import React from 'react'

const DocIconLined = () => {
    return (
        <svg
            // width="24" height="24"
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="2" width="16" height="20" rx="4" stroke="#2B3F6C" stroke-width="1.5" />
            <path opacity="0.33" d="M8 7H16" stroke="#2B3F6C" stroke-width="1.5" stroke-linecap="round" />
            <path opacity="0.33" d="M8 12H16" stroke="#2B3F6C" stroke-width="1.5" stroke-linecap="round" />
            <path opacity="0.33" d="M8 17H12" stroke="#2B3F6C" stroke-width="1.5" stroke-linecap="round" />
        </svg>


    )
}

export default DocIconLined